import { useTranslation } from 'libs/i18n'
import { useNavigate } from 'libs/router'
import { routes } from 'config/routes'
import type { Option } from 'shared/components/ContextMenu/types'
import type { TagItem } from 'features/tags/types/tags.types'

type UseContextMenuOptionsProps = {
	onEdit: (tag: TagItem) => void
	onDelete: (id: number) => void
}

export const useContextMenuOptions = ({
	onEdit,
	onDelete
}: UseContextMenuOptionsProps): Option[] => {
	const { t } = useTranslation()
	const navigate = useNavigate()

	return [
		{
			label: t('Edit'),
			action: (_id: number, tag: TagItem) => onEdit(tag)
		},
		{
			label: t('History'),
			action: (id: number) => navigate(routes.tagHistory(String(id)))
		},
		{
			label: t('Delete'),
			action: onDelete
		}
	]
}
